import { Button } from "@material-ui/core";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import OpenInNewTabIconHelper from "components/StyledMaterialUI/OpenInNewTabHelper";
import useStyles from "./styles";

function Footer() {
  const classes = useStyles();
  const url = t({
    id: "app.footer.url",
    message: "https://www.crisistextline.org/",
  });
  const ariaLabel = t({
    id: "app.footer.aria-label",
    message: "Read more on our website (opens in a new tab)",
  });

  return (
    <div className={classes.footer}>
      <span className={classes.title}>
        {/* @ts-ignore */}
        <Trans id="app.footer.text-before">
          Support Crisis Text Line by donating
        </Trans>{" "}
        <Button
          aria-label={ariaLabel}
          role="link"
          variant="text"
          color="secondary"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.readMoreOnSiteText}
          style={{ backgroundColor: "transparent" }}
        >
          {/* @ts-ignore */}
          <Trans id="app.footer.link-text">More Questions?</Trans>
          <OpenInNewTabIconHelper />
        </Button>
      </span>
    </div>
  );
}
export default Footer;
